import { PropsWithChildren } from 'react';

import { Box, Tooltip, Typography } from '@mui/material';
import { Delete, RadioButtonChecked, RadioButtonUnchecked } from '@mui/icons-material';

export const EventElementInputBox = ({
  name,
  dashed = false,
  children,
  showDelete = false,
  onDelete,
  deleteTooltip,
  error = false,
  isDefaultSource = false,
  isSourceBox = false,
  setAsDefaultSource,
}: PropsWithChildren<{
  name: string;
  onDelete: () => void;
  deleteTooltip: string;
  error?: boolean;
  dashed?: boolean;
  showDelete?: boolean;
  isDefaultSource?: boolean;
  isSourceBox?: boolean;
  setAsDefaultSource?: () => void;
}>) => {
  return (
    <Box
      width="100%"
      minWidth="420px"
      p={2.5}
      borderRadius={1}
      border={dashed ? '1px dashed' : '1px solid'}
      borderColor={error ? 'red' : 'highlight.secondary'}
      sx={{
        '&:hover': {
          borderColor: `${error ? 'red' : 'grey.600'}`,
        },
      }}
      position="relative"
      mb={4}
      textAlign="center"
    >
      <Box
        position="absolute"
        top="-15px"
        left="4px"
        bgcolor="white"
        px={1}
        py={0.5}
        fontWeight="bold"
        alignItems={'center'}
        display={'flex'}
      >
        {isSourceBox &&
          (isDefaultSource ? (
            <Tooltip title={'This is the default source'} placement="top">
              <RadioButtonChecked
                sx={{
                  color: '#1083DA',
                  cursor: 'default',
                  padding: '2px',
                }}
              ></RadioButtonChecked>
            </Tooltip>
          ) : (
            <RadioButtonUnchecked
              sx={{
                color: '#7e7e7e',
                cursor: 'pointer',
                padding: '3px',
              }}
              onClick={() => {
                setAsDefaultSource();
              }}
            ></RadioButtonUnchecked>
          ))}
        <Typography
          variant="body2"
          color={error ? 'red' : 'inherit'}
          marginLeft={isSourceBox ? '2px' : '0px'}
        >
          {name}
        </Typography>
      </Box>
      {showDelete && (
        <Tooltip title={deleteTooltip} placement="top">
          <Box
            position="absolute"
            top="-15px"
            right="4px"
            bgcolor="white"
            color="error.main"
            px={1}
            py={0.5}
            sx={{ cursor: 'pointer' }}
            onClick={onDelete}
          >
            <Delete fontSize="small" />
          </Box>
        </Tooltip>
      )}
      {children}
    </Box>
  );
};
